import { memo } from 'react';

import { Flex, Spin } from 'antd';

function LoadingBar({ size = 'large', fullscreen = false }) {
  return (
    <Flex className="h-full w-full" align="center" justify="center" gap="middle">
      <Spin size={size} fullscreen={fullscreen} />
    </Flex>
  );
}

export default memo(LoadingBar);
